const comma = (a) => {
  if (!a) return 0;
  if (a === 0 || a === '0') return 0;
  var parts = a.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts.join('.');
};

const commaDate = (a) => {
  if (!a) return 0;
  if (a === 0 || a === '0') return 0;
  var parts = a.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{2})+(?!\d))/g, '/');

  return parts.join('.');
};

const commaTime = (a) => {
  if (!a) return 0;
  if (a === 0 || a === '0') return 0;
  var parts = a.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{2})+(?!\d))/g, ':');

  return parts.join('.');
};

const remainTime = (reqDate) => {
  if (!reqDate) return 0;
  if (reqDate.indexOf('T') < 0) {
    reqDate = reqDate.replace(' ', 'T') + '+09:00';
  }
  return parseInt((new Date(reqDate).getTime() - new Date().getTime()) / 60000);
};

const formatKm = (a) => {
  return parseInt(a / 100) / 10 + 'km';
};

const remainTimeTag = (reqDate) => {
  // const remain = remainTime(reqDate);
  // return (
  //   <View style={{
  //     width: 35, height: 18,
  //     backgroundColor: remain < 0 ? color.pink : color.mainColor,
  //     borderRadius: 5, margin: 2
  //   }}>
  //     <Text style={{
  //         alignItems: 'center',
  //         fontSize: 11.3, letterSpacing: -0.57,
  //         textAlign: 'center', color: color.white
  //     }}>
  //         {remain < -999 ? -999 : remain}분
  //     </Text>
  //   </View>
  // );
};

const pastTime = (reqDate) => {
  if (!reqDate) return 0;
  if (reqDate.indexOf('T') < 0) {
    reqDate = reqDate.replace(' ', 'T') + '+09:00';
  }
  return parseInt((new Date().getTime() - new Date(reqDate).getTime()) / 60000);
};

const pastTimeTag = (reqDate) => {
  // const past = pastTime(reqDate);
  // return (
  //   <View style={{
  //     width: 35, height: 18,
  //     backgroundColor: color.lightgray,
  //     borderRadius: 5, margin: 2
  //   }}>
  //     <Text style={{
  //         alignItems: 'center',
  //         fontSize: 11.3, letterSpacing: -0.57,
  //         textAlign: 'center'
  //     }}>
  //         {past > 999 ? 999 : past}분
  //     </Text>
  //   </View>
  // );
};

const checkOverPrice = (price, overPrice, overPriceSetting) => {
  if (!price) price = '';
  price = price.replace(/,/g, '');
  if (isNaN(price)) {
    overPrice = false;
    return overPrice;
  }
  price = parseInt(price);
  if (price >= overPriceSetting && !overPrice) overPrice = true;
  if (price < overPriceSetting && overPrice) overPrice = false;
  return overPrice;
};

const calcPriceOfOrderPayments = (payments) => {
  let price = 0;
  payments.forEach((payment) => {
    price += payment.paymentAmount;
  });
  return price;
};

const rad = (x) => {
  return (x * Math.PI) / 180;
};

const getDist = (p1, p2) => {
  if (!p1 || !p2) return 100000000;
  const R = 6378137; // Earth’s mean radius in meter
  const dLat = rad(p2.latitude - p1.latitude);
  const dLong = rad(p2.longitude - p1.longitude);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.latitude)) *
      Math.cos(rad(p2.latitude)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return parseInt(d); // returns the distance in meter
};

const getZoom = (p1, p2) => {
  let maxDist = getDist(p1, p2);

  let cnt = 0;
  while (parseInt(maxDist / 2) > 0) {
    maxDist = parseInt(maxDist / 2);
    cnt += 1;
  }

  return 24 - cnt;
};

export {
  comma,
  commaDate,
  commaTime,
  formatKm,
  remainTime,
  remainTimeTag,
  pastTime,
  pastTimeTag,
  checkOverPrice,
  calcPriceOfOrderPayments,
  rad,
  getDist,
  getZoom,
};
